import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { HeadersEntity } from "../entities/headers-entity";
import { LineItemsEntity } from "../entities/line-items-entity";
import dayjs = require("dayjs");
@Injectable()
export class HeadersRepository extends Repository<HeadersEntity> {
    constructor(@InjectRepository(HeadersEntity) private headersRepository: Repository<HeadersEntity>
    ) {
        super(headersRepository.target, headersRepository.manager, headersRepository.queryRunner);
    }

    async getPdfNameCustomerNameRepo(): Promise<any> {
        const queryBuilder = this.createQueryBuilder('h')
            .select([
                'h.id AS id',
                'h.customer_name AS customerName',
                'h.pdf_file_name AS pdfFileName',
                'h.file_path AS pdfFilePath',
                'h.customer_po_no AS customerPONO',
                'h.created_at AS createdAt',
                'h.status AS status',
            ])
        const result = await queryBuilder.getRawMany();
        return result;
    }

    async getAllDataRepo(req: any): Promise<any> {
        const queryBuilder = this.createQueryBuilder('h')
            .select([
                'h.id AS id',
                'h.customer_number AS customerNumber',
                'h.customer_name AS customerName',
                'h.customer_po_no AS customerPONo',
                'h.supplierName AS supplier_name',
                'h.currency AS currency',
                'h.requested_date AS requestedDate',
                'h.delivery_method AS deliveryMethod',
                'h.payment_terms AS paymentTerms',
                'h.ship_to AS shipTo',
                'h.delivery_terms AS deliveryTerms',
                'h.packaging_terms AS packagingTerms',
                'h.supplier_reference AS supplierReference',
                // 'h.created_at AS createdAt',

                'line.headers_id AS headersId',
                'line.SNo AS SNo',
                'line.item_description AS itemDescription',
                'line.description1 AS description1',
                'line.description2 AS description2',
                'line.quantity AS quantity',
                'line.unit_measurement AS unitMeasurement',
                'line.price AS price',
                'line.price_unit AS priceUnit',
                'line.lineAmount AS line_amount',
                'line.item_number AS itemNumber',
                // 'line.createdAt AS lineCreatedAt',
            ])
            .leftJoin(LineItemsEntity, 'line', 'line.headers_id = h.id')
            .where('h.id = :id', { id: req.req });
        const rawResults = await queryBuilder.getRawMany();
        if (rawResults.length === 0) {
            return null;
        }
        const firstRow = rawResults[0];
        const header = {
            customerNumber: firstRow.customerNumber,
            customerName: firstRow.customerName,
            customerPONo: firstRow.customerPONo,
            supplierName: firstRow.supplier_name,
            currency: firstRow.currency,
            requestedDate: firstRow.requestedDate,
            deliveryMethod: firstRow.deliveryMethod,
            paymentTerms: firstRow.paymentTerms,
            shipTo: firstRow.shipTo,
            deliveryTerms: firstRow.deliveryTerms,
            packagingTerms: firstRow.packagingTerms,
            supplierReference: firstRow.supplierReference,
        };
        const lineItems = rawResults
            .filter(row => row.headersId !== null)
            .map(row => ({
                SNo: row.SNo,
                itemDescription: row.itemDescription,
                description1: row.description1,
                description2: row.description2,
                quantity: row.quantity,
                unitMeasurement: row.unitMeasurement,
                price: row.price,
                priceUnit: row.priceUnit,
                lineAmount: row.line_amount,
                itemNumber: row.itemNumber
            }));

        return {
            header,
            lineItems
        };
    }

}